import { useTranslation } from 'react-i18next';

import { type Board, useToggleFavorite } from '@/entities/board';

type FavoriteTarget = Pick<Board, 'id' | 'is_favorite'> & { workspace_id: string | null };

import styles from './BoardManage.module.css';

export function FavoriteButton({ board }: { board: FavoriteTarget }) {
  const { t } = useTranslation();
  const toggle = useToggleFavorite(board);
  const favorite = toggle.isPending ? !board.is_favorite : board.is_favorite;
  return (
    <button
      type="button"
      className={`${styles.favorite} ${favorite ? styles.favoriteOn : ''}`}
      aria-pressed={favorite}
      aria-label={t(favorite ? 'boards.unfavorite' : 'boards.favorite')}
      title={t(favorite ? 'boards.unfavorite' : 'boards.favorite')}
      disabled={toggle.isPending}
      onClick={() => {
        toggle.mutate(!board.is_favorite);
      }}
    >
      {favorite ? '★' : '☆'}
    </button>
  );
}
